import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Dashboard from "./Dashboard";
import Footer from "../components/Footer";
import Tagmapping from "./subpages/Tagmapping";
import Epubrolemapping from "./subpages/Epubrolemapping";
import Guideline from "./subpages/Guideline";
import Navigationbar from "../components/Navigationbar";
import Languagetag from "./subpages/Languagetag";
import Alttext from "./subpages/Alttext";
import PageIdCreation from "./subpages/PageIdCreation";
import Metadata from "./subpages/Metadata";
import Checklisterror from "./subpages/Checklisterror";
import Validationreport from "./subpages/Validationreport";
import TOCCompare from "./subpages/TOCCompare";
import { dashboarddata } from "../api/api";
import { PackageCreation } from "./subpages/PageCreation";
import VendorValidation from "./subpages/VendorValidation";
import LatexToHtml from "./subpages/LatexToHtml";
import GripList from "./subpages/GripList";
import AutoTagPdf from "./subpages/AutoTagPdf";

const Subpage = () => {
  const { pages } = useParams();
  const [selected, setSelected] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [pagesToNav, setPagesToNav] = useState(null);
  const navigate = useNavigate();
  const [apidata, setApiData] = useState();
  const [completed, setCompleted] = useState(false);
  // const [fileId, setFileId] = useState("");

  const { fileId } = useParams();

  const currentpage = pages.toLowerCase();

  const fetchdata = async () => {
    try {
      let data = await dashboarddata();
      if (data) {
        setApiData(data.data);
      } else {
        alert(data.error);
      }
    } catch (e) {
      alert(e);
    }
  };

  useEffect(() => {
    fetchdata();
  }, []);

  console.log(pages);

  useEffect(() => {
    if (Array.isArray(selected) && Array.isArray(selected[1])) {
      const filteredPages = selected[1].filter((items) =>
        ["1", "2", "3", "4", "5", "6", "7", "8"].includes(items)
      );
      setPagesToNav(filteredPages);
    } else {
      console.warn("Invalid selected structure:", selected);
    }
  }, [selected]);

  useEffect(() => {
    setPagesToNav(apidata?.[0].steps);
  }, [apidata]);

  // console.log(apidata);

  const choosepage = (i) => {
    const pageMapping = [
      "tag_mapping",
      "epub_role_mapping",
      "guideline_nav_xhtml",
      "language_tag",
      "alt_text_integration",
      "page_id_creation",
      "metadata_information",
    ];
    return pageMapping[i] || "dashboard";
  };

  function renderpages(fileId, nextpage) {
    console.log(nextpage, "nextpage");
    console.log(fileId, "next");

    nextpage > 0
      ? navigate(
          `/accessibility_epub/${fileId}/${nextpage}/${choosepage(
            nextpage - 1
          )}`
        )
      : navigate(`/accessibility_epub/dashboard`);
  }

  const render = () => {
    console.log(currentpage);

    if (currentpage === "dashboard") {
      return (
        <Dashboard
          apiData={apidata}
          renderpage={renderpages}
          setSelected={setSelected}
          setCurrentIndex={setCurrentIndex}
          currentIndex={currentIndex}
          pagesToNav={pagesToNav}
          completed={completed}
          setCompleted={setCompleted}
        />
      );
    }
    if (currentpage === "latex_to_html") {
      return <LatexToHtml />;
    }
       if (currentpage === "grip_list") {
      return <GripList />;
    }
    if (currentpage === "isc_cleaning_process") {
      return <VendorValidation />;
    }
    if (currentpage === "package_creation") {
      return <PackageCreation />;
    }
    if (currentpage === "tag_mapping") {
      return <Tagmapping renderpage={renderpages} />;
    }
    if (currentpage === "epub_role_mapping") {
      return <Epubrolemapping fileId={fileId} renderpage={renderpages} />;
    }
    if (currentpage === "guideline_nav_xhtml") {
      return <Guideline fileId={fileId} renderpage={renderpages} />;
    }
    if (currentpage === "language_tag") {
      return <Languagetag fileId={fileId} renderpage={renderpages} />;
    }
    if (currentpage === "alt_text_integration") {
      return <Alttext fileId={fileId} renderpage={renderpages} />;
    }
    if (currentpage === "page_id_creation") {
      return <PageIdCreation fileId={fileId} renderpage={renderpages} />;
    }
    if (currentpage === "metadata_information") {
      return (
        <Metadata
          fileId={fileId}
          renderpage={renderpages}
          setCompleted={setCompleted}
        />
      );
    }
    if (currentpage === "checklist_errors") {
      return <Checklisterror />;
    }
    if (currentpage === "epub_validation_report") {
      return <Validationreport />;
    }
    if (currentpage === "toc_vs_ncx_compare") {
      return <TOCCompare />;
    }
     if (currentpage === "autotag_pdf") {
      return <AutoTagPdf />;
    }
  };

  const renderNavigation = () => {
    if (
      currentpage === "tag_mapping" ||
      currentpage === "epub_role_mapping" ||
      currentpage === "guideline_nav_xhtml" ||
      currentpage === "language_tag" ||
      currentpage === "page_id_creation" ||
      currentpage === "alt_text_integration" ||
      currentpage === "metadata_information"
    ) {
      return <Navigationbar pages={pagesToNav} />;
    }
  };

  return (
    <div className="w-full flex flex-col bg-commonfill min-h-[calc(100vh-96px)] overflow-auto">
      <div>{renderNavigation()}</div>
      <div className="w-full h-auto">{render()}</div>
      <div className="w-full mt-auto">
        <Footer />
      </div>
    </div>
  );
};

export default Subpage;
